import { IHttpApi } from '@cian/http-api/shared';

import { IAddOfferToComparisonResponseSchema } from 'shared/repositories/offers-comparison/entities/add_offer_to_comparison/AddOfferToComparisonResponseSchema';
import {
  TAddOfferToComparisonRequest,
  fetchAddOfferToComparison,
} from 'shared/repositories/offers-comparison/v1/add-offer-to-comparison';

import { assertUnknownError } from './assert';
import { mapAddOfferToComparisonResponse, mapAddOfferToComparisonResponseError } from './mappers';

export async function addOfferToComparisonRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TAddOfferToComparisonRequest;
}): Promise<IAddOfferToComparisonResponseSchema> {
  const response = await fetchAddOfferToComparison({
    httpApi,
    parameters,
    config: {},
    mappers: {
      200: mapAddOfferToComparisonResponse,
      400: mapAddOfferToComparisonResponseError,
    },
  });

  assertUnknownError(response);

  return response.response as IAddOfferToComparisonResponseSchema;
}
